export default __webpack_public_path__ + "static/media/Pro-8.480b2cf1.png";